var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ac-top"},[_c('div',{staticClass:"ac-title",class:_vm.tips?'':'long'},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"ac-tips",class:_vm.red?'red':''},[_vm._v(_vm._s(_vm.tips))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-685e75d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/agent/AgentTitle.vue
// module id = null
// module chunks = 